import { FiLoader } from "react-icons/fi";
import { cx } from "class-variance-authority";
import { HStack, VStack } from "./composition/stack.layout";
import React from "react";

interface LoaderProps {
  message: string;
  direction?: "column" | "row";
}

export const GenericLoadingBounce = (props: LoaderProps) => {
  return (
    <VStack className="p-8 w-full h-[80vh] space-y-6 items-center justify-center">
      <img
        alt=""
        src="/v2/hi5.svg"
        className="animate-bounce animate-slow animate-animated animate-infinite"
      />
      <GenericLoading message={props.message} />
    </VStack>
  );
};

export const GenericLoadingOverlay = (props: LoaderProps) => {
  return (
    <div className={"fixed h-screen w-screen bg-overlay z-[9999]"}>
      <VStack
        className={"p-8 space-y-6 h-[80%] w-[full] justify-center items-center"}
      >
        <HStack className=" p-8 shadow-md rounded-md bg-white  space-x-6">
          <FiLoader className="animate-spin text-magenta mx-auto" size={24} />

          <span className={"mx-auto"}>{props.message}</span>
        </HStack>
      </VStack>
    </div>
  );
};

export const GenericLoading = (
  props: LoaderProps & {
    textClassName?: string;
  }
) => {
  return (
    <div
      className={cx(
        "flex gap-x-2 gap-y-2 items-center",
        props.direction === "column" ? "flex-col" : "flex-row"
      )}
    >
      <FiLoader className="animate-spin text-magenta" />
      <p className={props.textClassName}>{props.message}</p>
    </div>
  );
};

export const GenericLoadingPanel = (props: LoaderProps) => {
  return (
    <div className="px-6 py-4 shadow-md rounded-md bg-white">
      <GenericLoading message={props.message} />
    </div>
  );
};

export const GenericLoadingPageShell = (props: LoaderProps) => {
  return (
    <div className="grid grid-rows-[72px,1fr] bg-friendly-eskimo w-screen h-screen min-h-full min-w-full">
      <div className="bg-white px-6 shadow row-span-1 flex items-center">
        <div className=" w-12 h-12 shine" />
      </div>

      <div className="row-span-1 flex items-center justify-center animate-fadeIn animate-animated">
        <GenericLoading message={props.message} />
      </div>
    </div>
  );
};
